<template>
  <!-- 仓库管理 -->
  <div class="warehouse-list">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="名称/编码" @keydown.enter="resetSearch">
            <template #prefix>关键字</template>
          </el-input>
          <el-select v-model="searchInfo.warehouseType" placeholder="请选择仓库类型" clearable>
            <template #prefix>类型</template>
            <el-option label="物资仓" :value="1"/>
            <el-option label="临期仓" :value="2"/>
          </el-select>
          <el-select v-model="searchInfo.status" placeholder="请选择状态" clearable>
            <template #prefix>状态</template>
            <el-option label="启用" :value="1"/>
            <el-option label="停用" :value="0"/>
          </el-select>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button type="write" el-type="success" @click="openDialog()">新增仓库</page-button>
        </template>
      </search-condition>
      <list-table :show-shadow="false">
        <separator-page :show-border="true">
          <template #category>
            <tree-dictionary v-if="queryDeparts" :filter="true" v-model:dictionary-list="departTree" dictionary-type="MERCHANT_CATEGORY"
                             label-name="departName"
                             @clickCategory="clickCategory" :query-function="queryDeparts"
                             dialog-label="部门管理" :disabled="true"/>
          </template>
          <yq-table :data="dataList" height="100%" stripe border page-name="warehouseList">
            <yq-table-column label="仓库编码" prop="warehouseCode" width="150rem"/>
            <yq-table-column label="仓库名称" prop="warehouseName" min-width="180rem" :show-overflow-tooltip="true"/>
            <yq-table-column label="仓库类型" prop="warehouseType" width="120rem" align="center">
              <template v-slot="{row}">
                <el-tag size="small" :type="row.warehouseType === 1 ? 'info' : 'warning'">{{row.warehouseType === 1 ? '物资仓' : '临期仓'}}</el-tag>
              </template>
            </yq-table-column>
            <yq-table-column label="关联部门" prop="deptName" width="150rem"/>
            <yq-table-column label="地址" prop="address" min-width="200rem" :show-overflow-tooltip="true"/>
            <yq-table-column label="负责人" prop="managerName" width="120rem"/>
            <yq-table-column label="状态" prop="status" width="120rem" align="center">
              <template v-slot="{row}">
                <el-tag size="small" :type="row.status === 1 ? 'success' : 'info'">{{row.status === 1 ? '启用' : '停用'}}</el-tag>
              </template>
            </yq-table-column>
            <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
              <template v-slot="{row}">
                <table-button-group label="更多操作">
                  <table-button type="write" @click="openDialog(row)">编辑</table-button>
                  <table-button type="write" @click="updateStatus(row)">{{row.status === 1 ? '停用' : '启用'}}</table-button>
                  <table-button type="delete" el-type="danger" message="删除前将校验是否有关联业务数据" @click="toDelete(row)">删除</table-button>
                </table-button-group>
              </template>
            </yq-table-column>
          </yq-table>
        </separator-page>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>

    <!-- 新增/编辑弹窗 -->
    <el-dialog v-model="showDialog" :title="dialogData.id ? '编辑仓库' : '新增仓库'" dialog-width="2" :close-on-click-modal="false">
      <form-items :data="dialogData" :columns="2" label-width="2.4rem" icon-width="0">
        <form-item label="仓库名称" :required="true" name="warehouseName" error-message="请输入仓库名称">
          <el-input v-model="dialogData.warehouseName" placeholder="请输入仓库名称"/>
        </form-item>
        <form-item label="仓库编码">
          <el-input v-model="dialogData.warehouseCode" placeholder="留空自动生成" :disabled="!!dialogData.id"/>
        </form-item>
        <form-item label="仓库类型" :required="true" name="warehouseType" error-message="请选择仓库类型">
          <el-select v-model="dialogData.warehouseType">
            <el-option label="物资仓" :value="1"/>
            <el-option label="临期仓" :value="2"/>
          </el-select>
        </form-item>
        <form-item label="关联部门">
          <depart-select v-model="dialogData.departCode" :data="departTree" placeholder="请选择部门"/>
        </form-item>
        <form-item label="负责人">
          <employee-select v-model="dialogData.manager" placeholder="请选择负责人"/>
        </form-item>
        <form-item label="状态">
          <el-select v-model="dialogData.status">
            <el-option label="启用" :value="1"/>
            <el-option label="停用" :value="0"/>
          </el-select>
        </form-item>
        <form-item label="地址" :show-block="true">
          <el-input v-model="dialogData.address" placeholder="请输入仓库详细地址"/>
        </form-item>
        <form-item label="备注" :show-block="true">
          <el-input type="textarea" v-model="dialogData.remark" placeholder="备注信息"/>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showDialog = false">取消</page-button>
        <page-button type="write" el-type="primary" @click="saveData">保存</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import DepartSelect from "@/components/h5/data/DepartSelect.vue";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import warehouseApi from "@/api/normal/stock/warehouseApi";
import SeparatorPage from "@/components/h5/layout/SeparatorPage.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "WarehouseList",
  components: {
    TreeDictionary,
    FormItems, FormItem, DialogTable, DepartSelect, SeparatorPage,
    YqTableColumn, TableButtonGroup, TableButton,
    SearchCondition, FormPage, ListTable, ListPage, EmployeeSelect
  },
  data() {
    return {
      searchInfo: {pageNumber: 1},
      dataList: [],
      departTree: [],
      showDialog: false,
      dialogData: {},
      queryDeparts: null,
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    this.init();
    this.resetSearch();
    this.queryDeparts = this.queryDepartList
  },
  methods: {
    // 查询部门树
    queryDepartList() {
      return new Promise(resolve => {
        warehouseApi.queryDepartList().then(res => {
          resolve(res)
        });
      })
    },
    init() {

    },
    async queryList() {
      const {records, totalCount} = await warehouseApi.queryList(this.searchInfo);
      // 部门名称回填
      records.forEach(r => {
        r.deptName = this.getDeptName(r.departCode);
      });
      this.dataList = records;
      this.searchInfo.totalCount = totalCount;
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    getDeptName(departCode) {
      if (!departCode) return "";
      let d = this.findDepart(this.departTree, departCode);
      return d ? (d.departName || d.name) : "";
    },
    findDepart(list, departCode) {
      if (!list) return null;
      for (let i = 0; i < list.length; i++) {
        if (list[i].departCode === departCode) return list[i];
        let child = this.findDepart(list[i].children, departCode);
        if (child) return child;
      }
      return null;
    },
    openDialog(row) {
      if (row) {
        this.dialogData = JSON.parse(JSON.stringify(row));
      } else {
        this.dialogData = {warehouseName: "", warehouseCode: "", warehouseType: 1, departCode: "", manager: "", address: "", status: 1, remark: ""};
      }
      this.showDialog = true;
    },
    async saveData() {
      if (!this.dialogData.warehouseName) {
        this.$message.error("请输入仓库名称");
        return;
      }
      await warehouseApi.save(this.dialogData);
      this.showDialog = false;
      this.resetSearch();
    },
    async updateStatus(row) {
      const status = row.status === 1 ? 0 : 1;
      await warehouseApi.updateStatus(row.id, status);
      this.$message.success(status === 1 ? "已启用" : "已停用");
      this.resetSearch();
    },
    async toDelete(row) {
      await warehouseApi.delete(row.id);
      this.resetSearch();
    },
    clickCategory(data) {
      this.searchInfo.departCode = data.departCode;
      this.queryList();
    }
  }
};
</script>

<style lang="scss" scoped>
.warehouse-list {
  height: 100%;
}
</style>
